export type AvatarSurprise =
  | 'wink'
  | 'startle'
  | 'look-around'
  | 'shiver'
  | 'roll'
  | 'doze'

// Matches the length of each surprise's CSS animation
export const SURPRISE_DURATIONS: Record<AvatarSurprise, number> = {
  wink: 1200,
  startle: 1400,
  'look-around': 2000,
  shiver: 1000,
  roll: 1400,
  doze: 3600
}

export const ALL_SURPRISES = Object.keys(SURPRISE_DURATIONS) as AvatarSurprise[]

// Still allowed when the avatar must stay serious. The wink is left out: it
// could look out of place in front of a grieving family.
export const SERIOUS_SURPRISES: AvatarSurprise[] = ['look-around', 'startle']

export function isSurpriseAllowed(
  surprise: AvatarSurprise,
  playful: boolean
): boolean {
  return playful || SERIOUS_SURPRISES.includes(surprise)
}

export function allowedSurprises(
  surprises: AvatarSurprise[],
  playful: boolean
): AvatarSurprise[] {
  const base = surprises.length ? surprises : ALL_SURPRISES
  return base.filter((surprise) => isSurpriseAllowed(surprise, playful))
}

// Delay before the next surprise, in ms, between min and max seconds
export function surpriseDelay(
  minSeconds: number,
  maxSeconds: number,
  random: number = Math.random()
): number {
  const min = Math.max(1, minSeconds)
  const max = Math.max(min, maxSeconds)
  return (min + random * (max - min)) * 1000
}

// A random surprise, never the same one twice in a row when there is a choice
export function pickSurprise(
  surprises: AvatarSurprise[],
  last: AvatarSurprise | null,
  random: number = Math.random()
): AvatarSurprise | null {
  if (!surprises.length) {
    return null
  }
  const index = Math.floor(random * surprises.length)
  if (surprises.length > 1 && surprises[index] === last) {
    return surprises[(index + 1) % surprises.length]
  }
  return surprises[index]
}
